<template>
  <!-- 对话框 -->
  <el-dialog title="编辑支付参数" :visible.sync="show" :before-close="closeDialog" style="width:1000px; margin: 0 auto;">

    <!-- 基本信息表单 -->
    <div class="form-box">
      <el-form label-width="80px">



        <el-form-item label="APP唯一标识:" label-width='130px'>
          <el-input v-model="submit_data.appid" :placeholder="submit_rules.appid.placeholder" style="width: 160px;">
          </el-input>
        </el-form-item>

        <el-form-item label="微信支付商户号 :" label-width='130px'>
          <el-input v-model="submit_data.mch_id" :placeholder="submit_rules.mch_id.placeholder" style="width: 160px;">
          </el-input>
        </el-form-item>

        <el-form-item label="API密钥:" label-width='130px'>
          <el-input v-model="submit_data.api_key" :placeholder="submit_rules.api_key.placeholder" style="width: 160px;">
          </el-input>
        </el-form-item>

        <el-form-item label="APPID接口密码:" label-width='130px'>
          <el-input v-model="submit_data.appsecret" :placeholder="submit_rules.appsecret.placeholder"
            style="width: 160px;">
          </el-input>
        </el-form-item>

        <el-form-item label="状态:" label-width='130px'>
          <el-select v-model="submit_data.status" placeholder="请选择状态" style="width: 160px; margin-right: 20px;">
            <el-option label="启用" value="1">
            </el-option>
            <el-option label="禁用" value="0">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
        <el-button type="primary" @click="editMerchantsSubmit">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;

  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        _this.submit_data.wx_merchants_code = _this.data;

        _this.$post(
            "/Wechat/getMerchantsDetails", {
              wx_merchants_code: _this.data,
            },
          )
          .then(res => {

            _this.submit_data.appid = res.data.appid;
            _this.submit_data.mch_id = res.data.mch_id;
            _this.submit_data.api_key = res.data.api_key;
            _this.submit_data.appsecret = res.data.appsecret;
            _this.submit_data.status = res.data.status.val;

          }).catch(res => {

          })

      },

    },
    data() {
      return {

        show: false,



        // 表单提交数据
        submit_data: {
          wx_merchants_code: '',
          appid: '',
          mch_id: '',
          api_key: '',
          appsecret: '',
          status: ''
        },

        submit_rules: {
          appid: {
            placeholder: '请输入APP唯一标识',
            rules: {
              required: true,
              message: 'APP唯一标识错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          mch_id: {
            placeholder: '请输入微信支付商户号',
            rules: {
              required: true,
              message: '微信支付商户号错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          api_key: {
            placeholder: '请输入API密钥',
            rules: {
              required: true,
              message: 'API密钥错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          appsecret: {
            placeholder: '请输入APPID接口密码',
            rules: {
              required: true,
              message: 'APPID接口密码错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          status: {
            placeholder: '请选择状态',
            rules: {
              required: true,
              message: '状态未选择',
              regulation: 'special',
              rulesData: '0|1'
            }
          }

        },

      };
    },
    created() {
      _this = this;

    },
    methods: {




      // 关闭方法
      closeDialog() {

        _this.show = false;

        _this.submit_data = {
          wx_merchants_code: '',
          appid: '',
          mch_id: '',
          api_key: '',
          appsecret: '',
          status: ''
        }

      },

      // 提交按钮
      editMerchantsSubmit() {

        _this.$post(
            '/wechat/editMerchantsSubmit',
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {


            _this.$message.success(res.msg);

            _this.closeDialog();

            _this.$emit('onSubmit');


          }).catch((err) => {

          })

      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }
</style>